import { fetchNodeCatalog } from '../api';

/**
 * Кэш каталога узлов.
 *
 * Каталог одинаков для всех экранов и меняется только при активации пакета, поэтому промис
 * кэшируется на уровне модуля — иначе каждый график тянул бы его сам.
 *
 * Вынесен из хука отдельным модулем сознательно: это логика со сроком жизни и явной
 * инвалидацией, и проверять её надо тестами, а не глазами. Именно здесь однажды и сломалось —
 * `invalidateNodeCatalog` существовал, но не вызывался ниоткуда, и после смены набора нод
 * дашборд до перезагрузки вкладки работал со старым каталогом: старый список карточек и
 * старая версия пакета в запросах.
 */
export const NODE_CATALOG_TTL_MS = 5 * 60 * 1000;

let catalogPromise = null;
let catalogLoadedAt = 0;

export const invalidateNodeCatalog = () => {
  catalogPromise = null;
  catalogLoadedAt = 0;
};

const isExpired = () => catalogLoadedAt > 0 && Date.now() - catalogLoadedAt > NODE_CATALOG_TTL_MS;

/**
 * TTL — страховка от забытого вызова инвалидации, а не оптимизация. Явные вызовы есть
 * (см. LlmNodesTab), но цена забытого вызова у нас уже была, а пять минут задержки —
 * несопоставимо меньшая плата, чем «дашборд пуст до F5».
 */
export const loadNodeCatalog = () => {
  if (!catalogPromise || isExpired()) {
    catalogLoadedAt = Date.now();
    catalogPromise = fetchNodeCatalog().catch((error) => {
      // Провалившийся промис нельзя оставлять в кэше: иначе одна сетевая ошибка
      // навсегда прибивает секцию графиков до перезагрузки страницы.
      invalidateNodeCatalog();
      throw error;
    });
  }

  return catalogPromise;
};
